// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import isObject from './isObject';
import {isArray, uniq} from "lodash";


const isArrayLike = (obj: any) => {
    if(Array.isArray(obj))
        return true;
    else if(obj == null)
        return false;
    else if(Object.keys(obj).length > 0 && !Number.isNaN(Number.parseInt(Object.keys(obj)[0])) )
        return true;
    return false;
}

export function normalizeArray(param: any) {
    if(param == null)
        return null;
    if(Array.isArray(param))
        return param;
    else {
        const keys = Object.keys(param).sort((a, b) => parseInt(a) > parseInt(b))
        const arr = []
        const max = parseInt(keys[keys.length-1])
        for(var i = 0; i <= max; i++) {
            arr.push(param[i+""] || null)
        }
        return arr;
    }
}

/** Recursively merge deeply nested schema objects with _errors.
 *
 * @param obj1 - The first object to merge
 * @param obj2 - The second object to merge
 * @returns - A new object that is the merge of the two given objects
 */
export default function deepMerge(
    obj1: any,
    obj2: any,
) {
    if(obj2 == null)
        return null;
    return Object.keys(obj2).reduce((acc, key) => {
        const left = obj1 ? obj1[key] : {},
            right = obj2[key];
        if(key === '__errors' && isArray(left) && isArray(right)) {
            acc[key] = uniq(left.concat(right));
        } else if (isArrayLike(left) && isArrayLike(right)) {
            const l = normalizeArray(left)
            const r = normalizeArray(right);
            const bigger = l.length > r.length ? l : r;
            const lower = l.length <= r.length ? l : r;
            for (let idx = 0; idx < bigger.length; idx++ ) {
                if(idx < lower.length) {
                    bigger[idx] = deepMerge(bigger[idx], lower[idx])
                }
            }
            acc[key] = bigger;
        } else if (obj1 && isObject(obj1) && key in obj1 && isObject(right)) {
            acc[key] = deepMerge(left, right);
        } else {
            if(right != null)
                acc[key] = right;
        }
        return acc;
    }, Object.assign({}, obj1)); // Prevent mutation of source object.
}
